import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import BidSubmission from "../Procurement/Activitiies/BidSubmission";
import BidInvitation from "../Procurement/Activitiies/BidInvitation";
import PlanningTracking from "../Procurement/Activitiies/PlanningTracking";

import DraftBidding from "../Procurement/Activitiies/DraftBidding";
import SpecificProcurementNotice from "../Procurement/Activitiies/SpecificProcurementNotice";
import CustomStageView from "../Procurement/Activitiies/CustomStageView";
import LetterOfAcceptance from "../Procurement/Activitiies/LOA";
import ApprovalPayment from "../Procurement/Activitiies/ApprovalPayment";
import CompleteReport from "../Procurement/Activitiies/CompleteReport";
import ContractPublication from "../Procurement/Activitiies/ContractPublication";
import ContractSigning from "../Procurement/Activitiies/ContractSigning";
import ContractAwardDecision from "../Procurement/Activitiies/ContractAwardDecision";
import BidEvaluation from "../Procurement/Activitiies/BidEvaluation";
import PreQualificationDocuments from "../Procurement/Activitiies/PrequalificationDocuments/PreQualificationDocuments";
import BidderResponseReceiptWrapper from "../Procurement/Activitiies/BidderResponseReceipt";
import ReceiptOfResponseWrapper from "../Procurement/Activitiies/ReceiptOfResponse/ReceiptOfResponseWrapper";
import ContractSupervisionWrapper from "../Procurement/Activitiies/ContractSupervision/ContractSupervisionWrapper";
import LegalDocumentSigning from "../Procurement/Activitiies/LegalDocumentSigning";
import AwardOfContract from "../Procurement/Activitiies/AwardOfContract";
import CertificateOfNoObjectionWrapper from "../Procurement/Activitiies/CertificateOfNoObjection/CertificateOfNoObjectionWrapper";

const activities = {
  draftbiddingdocument: <DraftBidding />,
  specificprocurementnotice: <SpecificProcurementNotice />,
  bidsubmissionopeningminutes: <BidSubmission />,
  bidinvitation: <BidInvitation />,
  bidevaluationreportandrecommendationforawards: <BidEvaluation />,
  letterofacceptance: <LetterOfAcceptance />,
  contractawarddecision: <ContractAwardDecision />,
  contractsigning: <ContractSigning />,
  publicationofcontractaward: <ContractPublication />,
  planningandtracking: <PlanningTracking />,
  approvalofpayment: <ApprovalPayment />,
  completionreport: <CompleteReport />,
  preparationoftenderdocument: <SpecificProcurementNotice />,
  contractsupervisionandmanagement: <ContractSupervisionWrapper />,
  receiptofbiddersresponse: <BidderResponseReceiptWrapper />,
  receiptofresponses: <ReceiptOfResponseWrapper />,
  certificateofnoobjection: <CertificateOfNoObjectionWrapper />,
  signingoflegaldocument: <LegalDocumentSigning />,
  contractaward: <AwardOfContract />,
  awardofcontract: <AwardOfContract />,
  letterofintent: <AwardOfContract />,
  preparationofprequalificationdocuments: <PreQualificationDocuments />,
};

const ActivityPageWrapper = () => {
  const { activityName } = useParams();

  return <Fragment>{activities[activityName] || <CustomStageView />}</Fragment>;
};

export default ActivityPageWrapper;
